import {Box, Button, Chip, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {PoliceUser} from "../PoliceUser";
import {getHelpdeskTicketStatus} from "../../data/helpdesk/HelpdeskTicketStatus";
import {HelpdeskTicketResponse} from "../../data/helpdesk/HelpdeskTicketResponse";
import {HelpdeskPageninatedResponse} from "../../data/helpdesk/HelpdeskPageninatedResponse";
import {formatTimestamp} from "../../utils";

function statusColor(displayName: string | undefined): string {
    switch (displayName) {
        case "Unclaimed": return "red"
        case "Awaiting Creator Response": return "green"
        case "Reassigned": return "#21cc96"
        case "Awaiting Assignee Response": return "#bb3578"
        case "Closed": return "#7521cc"
        default: return "#f8ac59"
    }
}

function HelpdeskTicketRow({ticket}: { ticket: HelpdeskTicketResponse }) {
    const ticketStatus = getHelpdeskTicketStatus(ticket.status)
    return <TableRow>
        <TableCell sx={{whiteSpace: "nowrap", width: "40px"}}>{ticket.id}</TableCell>
        <TableCell sx={{width: "130px"}}>
            <Chip color="primary" style={{backgroundColor: statusColor(ticketStatus?.displayName)}}
                  label={ticketStatus?.displayName} size="small"/>
        </TableCell>
        <TableCell sx={{whiteSpace: "nowrap", width: "110px"}}>{formatTimestamp(ticket.date)}</TableCell>
        <TableCell sx={{width: "140px"}}>
            <PoliceUser user={{nick: ticket.creatorNick, communityId: ticket.creatorCommunityId}}/>
        </TableCell>
        <TableCell>{ticket.title}</TableCell>
        <TableCell sx={{width: "140px"}}>{ticket.divisionDisplayName}</TableCell>
        <TableCell sx={{width: "140px"}}>
            {ticket.assigneeNick && ticket.assigneeCommunityId
                ? <PoliceUser user={{nick: ticket.assigneeNick, communityId: ticket.assigneeCommunityId}}/>
                : "Unassigned"
            }
        </TableCell>
        <TableCell sx={{width: "100px"}}>
            <Button component={RouterLink} to={`/helpdesk/ticket/${ticket.id}`} color="success" size="small">
                View ({ticket.messages?.length ?? 0})
            </Button>
        </TableCell>
    </TableRow>
}

interface HelpdeskTicketTableProps {
    ticketData: HelpdeskPageninatedResponse
}

export function HelpdeskTicketTable({ticketData}: HelpdeskTicketTableProps) {
    return <Box sx={{overflowX: "auto"}}>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created</TableCell>
                    <TableCell>Creator</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Division</TableCell>
                    <TableCell>Assignee</TableCell>
                    <TableCell/>
                </TableRow>
            </TableHead>
            <TableBody>
                {ticketData.tickets.map(ticket => <HelpdeskTicketRow ticket={ticket} key={ticket.id}/>)}
            </TableBody>
        </Table>
    </Box>
}
